/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://jo7a6y1bk5.execute-api.eu-central-1.amazonaws.com/main",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://cjzlh6zokzgehocqd7pagfpxga.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-central-1:d1c1f173-c8d3-426a-a6cf-310fcb50de6b",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_07GFDqbPz",
    "aws_user_pools_web_client_id": "5heo3efvpklalp22fd61bn2r32",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "8",
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "domino-20190513222959-hostingbucket-main",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "http://domino-20190513222959-hostingbucket-main.s3-website.eu-central-1.amazonaws.com",
    "aws_user_files_s3_bucket": "dominoe7966d663fdd427abae3202a609d3c71-mainf7aad-main",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
